import { HStack, StackProps } from '@chakra-ui/react'

export default function InfoList({ children, ...props }: StackProps) {
  return (
    <HStack 
      spacing="20px" 
      justifyContent="space-between"
      ml="26px"
      sx={{
        '> div > span': {
          color: '#0A0D14',
          fontWeight: 500,
          small: {
            color: '#525866',
            fontWeight: 400,
            fontSize: '12px',
            letterSpacing: '-0.072px',
            display: 'block'
          }
        }
      }}
      {...props}
    >
      {children}
    </HStack>
  )
}
